import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBV-avfprZU77YfADicXIuYvXfN39YKP7Y",
  authDomain: "patiboxhsk.firebaseapp.com",
  databaseURL: "https://patiboxhsk-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "patiboxhsk",
  storageBucket: "patiboxhsk.appspot.com", // Corrected storageBucket
  messagingSenderId: "667768928550",
  appId: "1:667768928550:web:1385a9fe61c074151429e7",
  measurementId: "G-FZKHRRYTRB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const auth = getAuth(app);
const db = getFirestore(app);

console.log("Firebase initialized successfully!");

export { auth, db };